import { createContext } from 'react';
export var OptionContext = createContext({
    materials: {},
    meta: {},
    global: {},
    autoParseStyle: true,
    schema: {
        components: [],
        plugins: [],
    },
});
//# sourceMappingURL=OptionContext.js.map